import { render, staticRenderFns } from "./PosProductEmpty.vue?vue&type=template&id=d74aa506&scoped=true&"
import script from "./PosProductEmpty.vue?vue&type=script&lang=js&"
export * from "./PosProductEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74aa506",
  null
  
)

export default component.exports